import './Gruendung.css';
import gruendungImg from '../../assets/images/gruendung_main.jpeg';

function Gruendung() {
  return (
    <section id="gruendung" className="gruendung">
      <div className="gruendung__inner">

        <div className="gruendung__header">
          <span className="gruendung__label">Geschichte &amp; Vision</span>
          <h2 className="gruendung__title">Gründung – Rocaille</h2>
          <p className="gruendung__est">est. 2016</p>
          <div className="gruendung__divider" />
        </div>

        <div className="gruendung__layout">
          <div className="gruendung__img-wrap">
            <img src={gruendungImg} alt="Gründung Rocaille" className="gruendung__img" />
          </div>

          <div className="gruendung__content">
            <p className="gruendung__text">
              Im Frühjahr 2016 eröffnete in Düsseldorf das ROCAILLE – Café, Bistrot &amp; Weinbar.
              Das ganztägige Konzept vereint eine eigene Patisserie-Manufaktur mit einer
              außergewöhnlichen Weinkarte, die heute mehr als 2.000 Positionen umfasst. Bereits 2017
              und 2018 zeichnete der Feinschmecker das Rocaille als „Bestes Restaurant für jeden Tag
              in NRW" aus.
            </p>
            <p className="gruendung__text">
              Beim German Wine List Award 2018 erhielt das Rocaille von VINUM – Europe's Wine Magazine
              die Höchstwertung von fünf Sternen. Der Falstaff kürte das Haus zudem 2020, 2021 und 2022
              zum „Besten Weinbistro Deutschlands" und brachte die Begeisterung treffend auf den Punkt:
              „Wer hier nicht glücklich wird, wird es nirgendwo!"
            </p>
            <p className="gruendung__text">
              Auch DER SPIEGEL beschrieb das Konzept prägnant als „den neuen Genuss – anspruchsvolle
              Küche in entspannter Atmosphäre".
            </p>
            <p className="gruendung__text">
              Internationale Anerkennung folgte durch die renommierte Star Wine List, den weltweit
              führenden Guide für herausragende Weinbars und Weinrestaurants. Für die Star Wine List of
              the Year Germany 2023 wurde das Rocaille gleich in vier Kategorien nominiert:
              „Best Austrian Wine List", „Best New Generation Bordeaux List", „Best California Wine
              List" sowie in der Königskategorie „Grand Prix – Best Wine List with More Than 600
              References".
            </p>
            <p className="gruendung__text">
              Der aktuelle Falstaff Restaurant Guide 2026 fasst den Charakter des Hauses treffend
              zusammen: „Ein Weinbistro der Extraklasse. Hier geht es morgens mit einem Frühstück los,
              danach trumpft die marktfrische Bistroküche auf. Ein Dorado für Kenner und Einsteiger."
            </p>
            <p className="gruendung__text">
              Vielleicht noch passender und vom Falstaff auf den Punkt gebracht:
              „Bilderbuchweinbar mit angeschlossener Patisserie und beeindruckender Karte. Die Fahrt
              geht quer durch sämtliche Anbaugebiete und Stilistiken, dazu eine lässige marktfrische
              Bistrot-Küche. Passt!"
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Gruendung;
